import { StoreModel } from "../../models/Index";

export default function logError(Store: StoreModel, message: string) {
    return Store.shellClient.logError(message);
}
